<template>
  <div class="container-fluid position-relative">
    <!-- Dropship Component Steps 1 - 5 -->
    <Policy v-if="activeStep == 1"/>
    <Hub v-if="activeStep == 2"/>
    <BrowseProducts
      v-if="activeStep == 3"
      :mfg="activeMfg"
      :cart="cart"/>
    
    <!-- Step Tracker -->
    <Steps
      v-if="!mobile"
      :activeStep="activeStep"/>
    <!-- Product Modal -->
    <Modal :mfg="activeMfg"/>
  </div>
</template>

<script setup>
  import Steps from './components/Steps.vue';
  import Policy from './step1/Policy.vue';
  import Hub from './step2/Hub.vue';
  import BrowseProducts from './step3/BrowseProducts.vue';
  import Modal from './components/modal/Modal.vue';
  import { ref, computed, onBeforeMount, onMounted } from 'vue';
  import {useStore} from 'vuex';
  import { useRouter } from 'vue-router';
  import { dropshipAllowed } from '../../../../repositories/dropshipRepository'

  // Initialize
  const store = useStore()
  const mobile = ref(false)
  const body = ref(null)
  const router = useRouter()

  // LifeCycle
  onBeforeMount(()=>{
    if(dropshipAllowed()){
      store.dispatch('resetDropshipStep')
      window.addEventListener('resize', ()=>{
        setMobile(body.value)
      })
    }else{
      router.push({name: 'PrivateHome'})
    }
  })

  onMounted(()=>{
    body.value = document.getElementsByClassName('main-body')[0]
    setMobile(body.value)
  })

  // Methods
  const setMobile = (el)=>{
    mobile.value = el.clientWidth < 991
  }

  /* Computed */
  
  const activeStep = computed(()=>{
    return store.getters.dropshipStep
  })

  const activeMfg = computed(()=>{
    return store.getters.dropshipMfg
  })

  const cart = computed(()=>{
    return store.getters.cart
  })

</script>